import { useDeviceType } from '../../../../../responsive/hooks';
export function useGetIsMobileDevice() {
  const deviceType = useDeviceType();
  return deviceType === 'phone';
}